
<div class="container p-3">
  <h2>Counselling Individual Session</h2>
  <div class="row">
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Session Type</mat-label>
      <mat-select required  [(ngModel)]="sessionType">
        <mat-option *ngFor="let t of types" [value]="t">{{t}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Select Centre</mat-label>
      <mat-select  [(ngModel)]="selectedCentre">
        <mat-option *ngFor=" let c of (centres$|async) "
                    [value]="c.centreCode">{{c.centreName}} </mat-option>
        <!--      <mat-option  value="All">All Centres</mat-option>-->
      </mat-select>
    </mat-form-field>


<!--    <mat-form-field appearance="outline" class="col-md-4">-->
<!--      <mat-label >Select Name of Councelor</mat-label>-->
<!--      <mat-select  aria-label="Default select example" [(ngModel)]="counselorName">-->
<!--        <mat-option *ngFor="let e of (employee|async)" [value]="e.userName"> {{e.userName}}</mat-option>-->
<!--&lt;!&ndash;<prettyjson [obj]='employee|async'></prettyjson>&ndash;&gt;-->
<!--      </mat-select>-->
<!--    </mat-form-field>-->


    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>From</mat-label>
      <input matInput [matDatepicker]="startDatePicker" [(ngModel)]="startDate" readonly>
      <mat-hint>DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #startDatePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>To</mat-label>
      <input matInput [matDatepicker]="endDatePicker" [(ngModel)]="endDate" readonly>
      <mat-hint>DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #endDatePicker></mat-datepicker>
    </mat-form-field>

  </div>
  <div class="row">

    <mat-form-field appearance="legacy" class="col-md-6">
      <mat-label><span class="bi bi-search me-2"></span>Select Name</mat-label>
      <input matInput  (input)="applyFilter($event)" placeholder="Select Name" #input>
    </mat-form-field>

    <div class="col-md-6 text-end ">
      &nbsp;&nbsp;<button mat-mini-fab color="accent"  matTooltip="Search" (click)="Search()">
      <mat-icon>search</mat-icon>
    </button>&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;   <button mat-mini-fab color="accent"  (click)="clearAll()" matTooltip="Clear">
      <mat-icon>clear</mat-icon>

    </button>
    </div>

  </div>



  <section>

  </section>






</div>
<div class="example-container">
<table mat-table [dataSource]="dataSource" class="mat-elevation-z8 " matSort>

  <!--- Note that these columns can be defined in any order.
        The actual rendered columns are set as a property on the row definition" -->



  <!-- Name Column -->
  <ng-container matColumnDef="childName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Child Name </th>
    <td mat-cell *matCellDef="let element"> {{element.childName}} </td>
  </ng-container>
  <ng-container matColumnDef="childCode">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Child Code </th>
    <td mat-cell *matCellDef="let element"> {{element.childCode}} </td>
  </ng-container>
  <!-- Weight Column -->
  <ng-container matColumnDef="centreName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Centre Name </th>
    <td mat-cell *matCellDef="let element"> {{element.centreName}} </td>
  </ng-container>

  <!-- Symbol Column -->
  <ng-container matColumnDef="date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Session Date </th>
    <td mat-cell *matCellDef="let element"> {{(element.date).toDate() | date:'dd/MM/yyyy'}} </td>
  </ng-container>
  <!-- Position Column -->
  <ng-container matColumnDef="createdAt">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>CreatedAt </th>

    <td mat-cell *matCellDef="let element"> <span *ngIf='element.createdAt' >{{element?.createdAt|date:'dd/MM/yyyy' }}</span> </td>

  </ng-container>

  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Session Type </th>

    <td mat-cell *matCellDef="let element"> <span *ngIf='element.createdAt' >{{element?.type }}</span> </td>

  </ng-container>

  <ng-container matColumnDef="Action">
    <th mat-header-cell *matHeaderCellDef>Action</th>
    <td mat-cell *matCellDef="let element">
      <button mat-icon-button color="accent" (click)="viewDialog(element)" matTooltip="View">
        <mat-icon>remove_red_eye</mat-icon>
      </button>
    </td>
  </ng-container>
  <!-- Row shown when there is no matching data. -->
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" colspan="4"><span *ngIf="selectedCentre==null"> No Centre Selected</span>
      <span *ngIf="selectedCentre!=null">No data matching the filter "{{input.value}}"</span></td>
  </tr>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>


</table>
  <mat-paginator [pageSizeOptions]="[25,50,100,200,250,500,1000]" ></mat-paginator>

</div>





